export default "__VITE_ASSET__CPcdJpBs__"